import axios from 'axios';
import router from '@/router';

const api = axios.create({
  baseURL: '/api'
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

api.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("AccessToken");
    if (token) {
      token = token.replace(/^"|"$/g, '');
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response && (error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) {
      
      if (isRefreshing) {
        // 如果正在刷新中，將請求加入隊列
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return api(originalRequest);
        }).catch(err => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
       const refreshToken = localStorage.getItem("RefreshToken");
       
        // 發送刷新請求
        const res = await axios.post('/api/user/refreshtoken', {
            refresh_token: refreshToken
        });

        console.log('axios 61 401');
        console.log(res)

        const newToken = res.data.access_token;
        localStorage.setItem("AccessToken", newToken);
        
        // 執行隊列中的請求
        processQueue(null, newToken);
        isRefreshing = false;

        // 執行當前請求
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return api(originalRequest);

      } catch (refreshError) {
        processQueue(refreshError, null);
        isRefreshing = false;
        /*
        console.error('RefreshToken 過期或失效，引導至登入頁');
        localStorage.removeItem("AccessToken");
        localStorage.removeItem("RefreshToken");
        router.push('/login');
        */

        console.warn('連 Refresh Token 也失效了，強制登出');
        localStorage.removeItem("AccessToken");
        localStorage.removeItem("RefreshToken");
          
        // 確保這裡執行
        router.push('/login'); 
  
        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;